<template>
  <div class="app-container">
    <router-view v-slot="{ Component }">
      <component :is="Component" :key="$route.fullPath" />
    </router-view>
  </div>
</template>

<script setup>
import { onMounted, onUnmounted, watch } from 'vue'
import { useRoute } from 'vue-router'
import { useLangStore } from './stores/lang'

const langStore = useLangStore()
const route = useRoute()

onMounted(() => {
  langStore.initLang()
})

onUnmounted(() => {
  langStore.cleanup()
})

// 监听路由变化
watch(() => route.fullPath, () => {
  // 给DOM一点时间更新
  setTimeout(() => {
    langStore.translateFullPage()
  }, 100)
})
</script>

<style>
html,
body {
  margin: 0;
  padding: 0;
  height: 100%;
  width: 100%;
}

#app {
  height: 100%;
  width: 100%;
}

.app-container {
  height: 100%;
  width: 100%;
  position: relative;
}

.lang-switch {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 1000;
}

/* 重置一些基础样式 */
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

/* element-plus 布局组件样式覆盖 */
.el-container {
  height: 100%;
  width: 100%;
}

.el-aside {
  height: 100vh;
  overflow-x: hidden;
  overflow-y: auto;
}

.el-header {
  height: 60px;
  line-height: 60px;
}

.el-main {
  padding: 20px;
  height: calc(100vh - 60px);
  overflow-y: auto;
}
</style>
